import { instance } from "../../lib/api";
import Constants from "../../utils/CommonConstants";

export const RENEWAL_DASHBOARD_GRAPH_DATA = "RENEWAL_DASHBOARD_GRAPH_DATA";
export const getRenewalGraphData = (filters = {}) => {
  const url = "sapna/renewal-report/trends";
  return (dispatch) => {
    return instance({
      url,
      method: "get",
      params: filters,
    })
      .then((res) => {
        dispatch({
          type: RENEWAL_DASHBOARD_GRAPH_DATA,
          payload: res && res.data && res.data.data ? res.data.data : {},
        });
      })
      .catch((err) => {
        dispatch({
          type: Constants.API_FAIL,
          errMsg: Constants.getErrorMessage(err),
        });
      });
  };
};
